import firebase from "firebase/app";
import "firebase/functions";

export type MissYouEventStatus = "upcoming" | "open" | "closed";
export type MissYouReason =
  | "ok"
  | "registered-this-month"
  | "phone-already-claimed"
  | "not-existing-customer"
  | "no-deposit-yet"
  | "first-deposit-amount-mismatch"
  | "deposit-before-window";
export type MissYouCreditStatus =
  | "pending"
  | "crediting"
  | "credited"
  | "failed"
  | "dispatch-failed";

export interface MissYouDeposit {
  id: string;
  qty: number;
  createdate: string;
}

export interface MissYouClaim {
  claimId: string;
  depositId: string;
  depositQty: number;
  depositCreatedate: string;
  bonus: number;
  claimedAtMs: number;
  creditStatus: MissYouCreditStatus;
  creditedAtMs: number;
}

export interface MissYouStatusResponse {
  eventId: string;
  eventStatus: MissYouEventStatus;
  claimStartAtMs: number;
  claimEndAtMs: number;
  depositAmount: number;
  receiveTotal: number;
  bonus: number;
  eligible: boolean;
  reason: MissYouReason;
  firstDeposit: MissYouDeposit | null;
  claim: MissYouClaim | null;
}

export interface MissYouClaimResponse {
  success: boolean;
  alreadyClaimed: boolean;
  claim: MissYouClaim;
}

function missYouFunctions() {
  return firebase.app().functions("asia-east2");
}

export async function getMissYouStatus(
  accessToken: string
): Promise<MissYouStatusResponse> {
  const callable = missYouFunctions().httpsCallable("getMissYouStatus");
  const result = await callable({ accessToken });
  return result.data as MissYouStatusResponse;
}

export async function claimMissYouReward(
  accessToken: string
): Promise<MissYouClaimResponse> {
  const callable = missYouFunctions().httpsCallable("claimMissYouReward");
  const result = await callable({ accessToken });
  return result.data as MissYouClaimResponse;
}
